module.exports = __webpack_public_path__ + "static/img/cont8.fbeaf3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont8.jpg
// module id = jf7O
// module chunks = 0